import DOMPurify, { clearWindow } from 'isomorphic-dompurify';

// On the server, isomorphic-dompurify sanitizes inside one long-lived jsdom window,
// and every call leaves an event listener behind on it. Replace the window
// periodically so that state doesn't pile up until the server runs out of heap.
const CLEAR_WINDOW_EVERY = 500;
let serverSanitizeCalls = 0;

export default function sanitizeHTML(html: string, options?: object): string {
  const mergedOptions = {
    ...options,
  };
  const clean = DOMPurify.sanitize(html, mergedOptions);

  if (import.meta.server && ++serverSanitizeCalls >= CLEAR_WINDOW_EVERY) {
    serverSanitizeCalls = 0;
    clearWindow();
  }

  return clean;
}
